import { defineStyleConfig } from '@chakra-ui/react'

const Button = defineStyleConfig({
    // The styles all button have in common
    // TODO: Make the button component reusuable through these styles
    baseStyle: {},
    sizes: {},
    variants: {},
    defaultProps: {},
})

export default Button